function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, toRefs, watch, computed, reactive } from "vue";
import { definePropType } from "@types-vue/props";
import { Operation, statusesOptions } from "../label/label-config";
import { fromSchema, fromModel } from "../label/label.dialog";
import { delTag, updateTag, saveTag } from "@/api/material_label";
import { Message } from "element-ui";
import _ from "lodash";
export default defineComponent({
    name: "label-dialog",
    props: {
        visible: {
            type: definePropType(Boolean),
            default: false,
            required: true
        },
        tableItemInfo: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit, attrs = param.attrs;
        var resetForm = function resetForm() {
            var _$ref, _$ref1;
            if (!fromRef) return;
            (_$ref = fromRef.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
            (_$ref1 = fromRef.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.clearValidate();
        };
        var isConfirm = ref(false);
        var isUpdate = ref(false);
        var isModification = ref(false);
        var saveLoading = ref(false);
        var dialogTitle = ref("");
        var confirmTitle = ref("");
        var confirmContent = ref("");
        var labelRadio = ref(2);
        var fromRef = ref();
        var fromSchemaData = reactive({
            fromSchema: {}
        });
        var fromModelData = reactive({
            fromModel: fromModel
        });
        var formConfig = computed(function() {
            return {
                inline: false,
                labelPosition: "right",
                labelWidth: "110px"
            };
        });
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        watch(function() {
            return props.tableItemInfo;
        }, function(val) {
            isConfirm.value = false;
            isUpdate.value = false;
            isModification.value = false;
            if (val.operation === Operation.DELETE) {
                isConfirm.value = true;
                confirmTitle.value = "\u786E\u5B9A\u5220\u9664\u6807\u7B7E\u5417?";
                confirmContent.value = "\u786E\u5B9A\u5220\u9664\u6807\u7B7E\u5417?\u5220\u9664\u540E,\u4E0D\u53EF\u4F7F\u7528\u8BE5\u6807\u7B7E\u8FDB\u884C\u8D44\u6E90\u7B5B\u9009\u6216\u6253\u6807\u64CD\u4F5C\u3002\u5DF2\u88AB\u4F7F\u7528\u7684\u6807\u7B7E\u4E0D\u53EF\u4EE5\u5220\u9664\u3002\u6B64\u64CD\u4F5C\u4E0D\u53EF\u6062\u590D\uFF0C\u8BF7\u786E\u8BA4\u3002";
            }
            if (val.operation === Operation.ADDLABEL) {
                dialogTitle.value = "\u65B0\u589E\u6807\u7B7E\u503C";
            }
            if (val.operation === Operation.REVISE) {
                dialogTitle.value = "\u4FEE\u6539\u6807\u7B7E\u503C";
            }
            if (val.operation === Operation.BATCHDE) {
                isUpdate.value = true;
                labelRadio.value = 2;
                dialogTitle.value = "\u6279\u91CF\u4FEE\u6539";
            }
            if (val.id) {
                var _group_id;
                fromModelData.fromModel = _.assign(_.pick(val, [
                    "id",
                    "name",
                    "name_en",
                    "status",
                    "description",
                    "icon_url", 
                ]), {
                    group_id: (_group_id = val.group_id) !== null && _group_id !== void 0 ? _group_id : ""
                });
            } else {
                fromModelData.fromModel = _.cloneDeep(fromModel);
                resetForm();
            }
        });
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                fromSchemaData.fromSchema = fromSchema();
                if (fromModelData.fromModel.icon_url) {
                    var iconName = fromModelData.fromModel.icon_url.split("/");
                    fromModelData.fromModel.fileList = [
                        {
                            name: iconName[iconName.length - 1].split("?")[0] || "",
                            url: fromModelData.fromModel.icon_url
                        }, 
                    ];
                    fromSchemaData.fromSchema.properties.icon_url.field.fileList = fromModelData.fromModel.fileList;
                }
            }
        });
        var dialogAttrs = computed(function() {
            return _objectSpread({
                title: isConfirm.value ? "" : dialogTitle.value,
                width: isConfirm.value || isUpdate.value ? "450px" : "980px",
                center: isConfirm.value === true
            }, attrs);
        });
        var successForm = function() {
            Message.success("\u64CD\u4F5C\u6210\u529F");
            saveLoading.value = false;
            emit("update:visible", false);
            emit("refreshList");
        };
        var handleSaveLabel = function() {
            var _ref1 = _asyncToGenerator(regeneratorRuntime.mark(function _callee1() {
                var params2, params1, _$ref;
                return regeneratorRuntime.wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            saveLoading.value = true;
                            if (!isModification.value) {
                                _ctx1.next = 14;
                                break;
                            }
                            params2 = {
                                field: "status",
                                value: String(labelRadio.value),
                                ids: String(props.tableItemInfo.id)
                            };
                            _ctx1.prev = 3;
                            _ctx1.next = 6;
                            return updateTag(params2);
                        case 6:
                            successForm();
                            _ctx1.next = 12;
                            break;
                        case 9:
                            _ctx1.prev = 9;
                            _ctx1.t0 = _ctx1["catch"](3);
                            saveLoading.value = false;
                        case 12:
                            _ctx1.next = 35;
                            break;
                        case 14:
                            if (!isConfirm.value) {
                                _ctx1.next = 27;
                                break;
                            }
                            params1 = {
                                ids: String(props.tableItemInfo.id)
                            };
                            _ctx1.prev = 16;
                            _ctx1.next = 19;
                            return delTag(params1);
                        case 19:
                            successForm();
                            _ctx1.next = 25;
                            break;
                        case 22:
                            _ctx1.prev = 22;
                            _ctx1.t1 = _ctx1["catch"](16);
                            saveLoading.value = false;
                        case 25:
                            _ctx1.next = 35;
                            break;
                        case 27:
                            if (!isUpdate.value) {
                                _ctx1.next = 31;
                                break;
                            }
                            {
                                isConfirm.value = true;
                                isModification.value = true;
                                confirmTitle.value = "\u786E\u5B9A\u6279\u91CF\u4FEE\u6539\u6807\u7B7E\u72B6\u6001\u5417?";
                                confirmContent.value = "\u786E\u8BA4\u4FEE\u6539\u72B6\u6001\u5417?\u4E0D\u53EF\u4F7F\u7528\u5931\u6548\u6807\u7B7E\u8FDB\u884C\u8D44\u6E90\u7B5B\u9009\u6216\u6253\u6807\u64CD\u4F5C\u3002\u5DF2\u6253\u6807\u7684\u8D44\u6E90\u65E0\u5F71\u54CD\u3002\u8BF7\u786E\u8BA4\u3002";
                                saveLoading.value = false;
                            // 新增、修改
                            }
                            _ctx1.next = 35;
                            break;
                        case 31:
                            ;
                            if (fromRef) {
                                _ctx1.next = 34;
                                break;
                            }
                            return _ctx1.abrupt("return");
                        case 34:
                            (_$ref = fromRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function() {
                                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(valid) {
                                    var params;
                                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                if (!valid) {
                                                    _ctx.next = 15;
                                                    break;
                                                }
                                                if (fromModelData.fromModel.icon_url && fromModelData.fromModel.icon_url.indexOf("https") !== -1) {
                                                    delete fromModelData.fromModel.icon_url;
                                                }
                                                delete fromModelData.fromModel.fileList;
                                                params = _objectSpreadProps(_objectSpread({}, fromModelData.fromModel), {
                                                    id: props.tableItemInfo.id
                                                });
                                                _ctx.prev = 4;
                                                _ctx.next = 7;
                                                return saveTag(params);
                                            case 7:
                                                successForm();
                                                _ctx.next = 13;
                                                break;
                                            case 10:
                                                _ctx.prev = 10;
                                                _ctx.t0 = _ctx["catch"](4);
                                                saveLoading.value = false;
                                            case 13:
                                                _ctx.next = 16;
                                                break;
                                            case 15:
                                                {
                                                    saveLoading.value = false;
                                                }
                                            case 16:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            4,
                                            10
                                        ]
                                    ]);
                                }));
                                return function(valid) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        case 35:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1, null, [
                    [
                        3,
                        9
                    ],
                    [
                        16,
                        22
                    ]
                ]);
            }));
            return function handleSaveLabel() {
                return _ref1.apply(this, arguments);
            };
        }();
        return _objectSpreadProps(_objectSpread({
            fromRef: fromRef
        }, toRefs(fromSchemaData), toRefs(fromModelData)), {
            isUpdate: isUpdate,
            isConfirm: isConfirm,
            saveLoading: saveLoading,
            labelRadio: labelRadio,
            formConfig: formConfig,
            dialogTitle: dialogTitle,
            dialogVisible: dialogVisible,
            dialogAttrs: dialogAttrs,
            confirmTitle: confirmTitle,
            confirmContent: confirmContent,
            statusesOptions: statusesOptions,
            handleSaveLabel: handleSaveLabel
        });
    }
});
